export default "__VITE_ASSET__PZX0QEFq__"